import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private queryData = [];
    settings: any = {
        appName: environment.APP_NAME,
        appLanguage: 'en',
        appDirection: 'ltr',
        appNotification: false,
        appDarkMode: false,
        currentUser: null,
        appCurrency: 'KWD'
    };
    constructor(private translate: TranslateService
    ) {
    }
        async loadAppSettings(): Promise<void> {
        const { value } = await Preferences.get({ key: 'appSettings' });
        if (value) {
          this.settings = JSON.parse(value);
        } else {
          await Preferences.set({
            key: 'appSettings',
            value: JSON.stringify(this.settings),
          });
        }
        const lang = this.settings.appLanguage || 'en';
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
      }
    
    //   getAppSettings(): Promise<any> {
    //     return Preferences.get({ key: 'appSettings' }).then(({ value }) => value);
    //   }
    getAppSettings = () => {
        return new Promise(async (resolve) => {
            const { value } = await Preferences.get({ key: 'appSettings' });
            if (value) {
                resolve(value);
            } else {
                await Preferences.set({
                    key: 'appSettings',
                    value: JSON.stringify(this.settings),
                });
                resolve(JSON.stringify(this.settings));
            }
        });
    }
    setStorage = async (keyStorage: any, givenSettings: any) => {
        await Preferences.set({
            key: keyStorage,
            value: JSON.stringify(givenSettings),
        });
    };
    getStorage = async (keyStorage: string) => {
        const { value } = await Preferences.get({ key: keyStorage }) as any;
        return JSON.parse(value);
    };
    removeStorage = async (keyStorage: string) => {
        await Preferences.remove({ key: keyStorage });
    };
    public setQueryData = (id, data) => {
        this.queryData[id] = data;
    }
    public getQueryData = (id) => {
        return this.queryData[id];
    }
}
